<template>
    <div class="mix_pay">
        <van-icon name="cross" class="close" @click="close"/>
        <p class="tit">支付详情</p>
        <p class="price">
            <i>&yen;</i>
            <span class="price1">{{ selection.price | arr_price1 }}</span>
            <span class="price2">.{{ selection.price | arr_price2 }}</span>
        </p>
        <div class="pay_box">
            <p class="p_tit">
                <span>{{ showmix ? '组合付款': '请选择支付方式' }}</span>
                <span class="back_mix" v-if="showmix" @click="reback">返回重选</span>
            </p>
            <ul class="chooses" v-show="!showmix">
                <li class="choose_item first_choice" v-if="Number(selection.balance) > 0" :class="{'active': pay_choose.includes(1)}" @click="choose1">
                    <div class="left">
                        <div class="img yue"></div>
                        <p>余额(可用：&yen;&nbsp;{{ selection.balance }})</p>
                    </div>
                    <div class="right">
                        <span v-if="Number(this.selection.balance) > 0 && Number(this.selection.balance) < Number(this.selection.price)">需组合付款</span>
                        <div class="choice">
                            <van-icon name="success" color="var(--theme)"/>
                        </div>
                    </div>
                </li>
                <li class="choose_item" :class="{'active': pay_choose.includes(2)}" @click="choose2">
                    <div class="left">
                        <div class="img"></div>
                        <p>支付宝支付</p>
                    </div>
                    <div class="right">
                        <div class="choice">
                            <van-icon name="success" color="var(--theme)"/>
                        </div>
                    </div>
                </li>
            </ul>
            <ul class="chooses" v-show="showmix">
                <li class="choose_item first_choice">
                    <div class="left">
                        <div class="img yue"></div>
                        <p>余额</p>
                    </div>
                    <div class="right">
                        <span>支付</span>
                        <em>&yen;{{ selection.balance }}</em>
                    </div>
                </li>
                <li class="choose_item">
                    <div class="left">
                        <div class="img"></div>
                        <p>支付宝</p>
                    </div>
                    <div class="right">
                        <span>支付</span>
                        <em>&yen;{{ mixPayAmount }}</em>
                    </div>
                </li>
            </ul>
        </div>
        <van-button round color="var(--theme)" class="pay_btn" @click="payFunc">
            {{ text }}
        </van-button>
    </div>
</template>

<script>
    export default {
        props: ['selection'],
        filters: {
            arr_price1(price) {
                if(price.toString().includes('.')) {
                    return price.toString().split('.')[0]
                }else {
                    return price
                }
            },
            arr_price2(price) {
                if(price.toString().includes('.')) {
                    return price.toString().split('.')[1]
                }else {
                    return '00'
                }
            }
        },
        data() {
            return {
                choose: null,
                text: '',
                pay_choose: [],
                showmix: false
            }
        },
        computed: {
            mixPayAmount() {
                return this.formatUpAmount(Number(this.selection.price) - Number(this.selection.balance))
            }
        },
        created() {

        },
        mounted() {
            this.$nextTick(() => {
                if(Number(this.selection.balance) == 0) {
                    this.pay_choose = [2]
                    this.text = '使用支付宝付款'
                }
                if(Number(this.selection.balance) > 0 && Number(this.selection.balance) < Number(this.selection.price)) {
                    this.pay_choose = [1,2]
                    this.text = '前往组合付款'
                }
                if(Number(this.selection.balance) >= Number(this.selection.price)) {
                    this.pay_choose = [1]
                    this.text = '使用余额付款'
                }
            })
        },
        methods: {
            close() {
                this.$emit('handleClose')
            },
            choose1() {
                if(Number(this.selection.balance) >= Number(this.selection.price)) {
                    if(!this.pay_choose.includes(1)) {
                        this.pay_choose = [1]
                        this.text = '使用余额付款'
                    }
                }
                if(Number(this.selection.balance) > 0 && Number(this.selection.balance) < Number(this.selection.price)) {
                    if(this.pay_choose.includes(1)) {
                        this.pay_choose = [2]
                        this.text = '使用支付宝付款'
                    }else {
                        this.pay_choose = [1,2]
                        this.text = '前往组合付款'
                    }
                }
            },
            choose2() {
                if(Number(this.selection.balance) >= Number(this.selection.price)) {
                    if(!this.pay_choose.includes(2)) {
                        this.pay_choose = [2]
                        this.text = '使用支付宝付款'
                    }
                }
            },
            payFunc() {
                if(this.text == '前往组合付款') {
                    this.showmix = true
                    this.text = '确认付款'
                }else {
                    var pay_type = '';
                    var pay_amount = 0
                    if(this.pay_choose.length == 1&& this.pay_choose[0] == 1) {
                        pay_type = 1
                    }
                    else if(this.pay_choose.length == 1&& this.pay_choose[0] == 2) {
                        pay_type = 2
                        pay_amount = Number(this.selection.price)
                    }else {
                        pay_type = 3
                        pay_amount = this.mixPayAmount
                    }
                    this.$emit('handleSuccess',{pay_type,pay_amount})
                }
            },
            formatUpAmount(value) {
                const amount = Number(value)
                if (!Number.isFinite(amount) || amount <= 0) {
                    return '0.00'
                }
                return (Math.ceil(amount * 100) / 100).toFixed(2)
            },
            reback() {
                this.showmix = false
                this.text = '前往组合付款'
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
.mix_pay {
    padding: 2.5rem 1rem;
    position: relative;
    background-color: #fbfbfb;
    .close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        font-size: 2rem;
        color: #000;
        cursor: pointer;
    }
    .tit {
        font-size: 1.6rem;
        text-align: center;
        margin-bottom: 2rem;
        font-weight: 700;
    }
    .price {
        text-align: center;
        font-weight: 700;
        margin-bottom: 2.5rem;
        i {
            display: inline-block;
            font-size: 2.5rem;
            margin-right: 1.2rem;
            transform: translateY(-.6rem);
        }
        .price1 {
            font-size: 5rem;
        }
        .price2 {
            font-size: 3rem;
        }
    }
    .pay_box {
        background-color: #fff;
        border-radius: 1rem;
        padding: 1.4rem 1.2rem;
        .p_tit {
            font-size: 1.4rem;
            color: #aaa;
            display: flex;
            justify-content: space-between;
            .back_mix {
                color: #2190FF;
            }
        }
        .chooses {
            .choose_item {
                padding: 2rem 0;
                display: flex;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                &.first_choice {
                    position: relative;
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 90%;
                        height: 1px;
                        background-color: #f2f2f2;
                    }
                }
                .left {
                    display: flex;
                    align-items: center;
                    font-size: 1.3rem;
                    color: #000;
                }
                .img {
                    margin-right: .5rem;
                    width: 2rem;
                    height: 2rem;
                    background-position: 0 0;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    background-image: url(../../assets/version_1.3.0/pay/zfb.png);
                    &.yue {
                        background-image: url(../../assets/version_1.3.0/pay/ye.png);
                    }
                }
                .right {
                    display: flex;
                    align-items: center;
                    span {
                        font-size: 1.4rem;
                        color: #aaa;
                        margin-right: .9rem;
                    }
                    em {
                        font-size: 1.4rem;
                        color: #000;
                        transform: translateY(0.1rem);
                    }
                    .choice {
                        width: 2rem;
                        height: 2rem;
                        border-radius: 50%;
                        border: 1px solid #aaa;
                        .van-icon {
                            display: none;
                        }
                    }
                }
                &.active {
                    .right {
                        .choice {
                            border-color: #FFE4D8;
                            background-color: #FFE4D8;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            .van-icon {
                                display: block;
                                font-size: 1.4rem;
                                transform: translate(0.1rem,0.1rem);
                            }
                        }
                    }
                }
            }
        }
    }
    .pay_btn {
        margin-top: 1.6rem;
        width: 100%;
        height: 4rem;
        color: #fff;
        font-size: 1.6rem;
    }
}
</style>
